import { NavLink, Outlet, useNavigate } from 'react-router';
import { NotFound } from '../App';
import { useMe } from '../admin/auth';
import { api } from '../lib/api';
import { Wordmark } from '../lib/Brand';
import { Icon } from '../lib/Icon';

/** Shell for /platform-admin. The server enforces admin-only access; this just hides the screens. */
export function PlatformLayout() {
  const { user } = useMe();
  const navigate = useNavigate();
  if (user.role !== 'PLATFORM_ADMIN') return <NotFound />;

  async function logout() {
    await api.logout().catch(() => undefined);
    navigate('/admin/login', { replace: true });
  }

  return (
    <div className="pa">
      <header className="pa-bar">
        <div className="pa-bar-inner">
          <div className="pa-brand">
            <Wordmark />
            <span className="pa-kicker">Platform admin</span>
          </div>
          <nav className="pa-nav" aria-label="Platform admin">
            <NavLink to="/platform-admin" end>Dashboard</NavLink>
            <NavLink to="/platform-admin/requests">Requests</NavLink>
            <NavLink to="/platform-admin/sellers">Sellers</NavLink>
            <NavLink to="/platform-admin/sales">Sales</NavLink>
          </nav>
          <button className="icon-btn" onClick={logout} aria-label="Log out" title="Log out"><Icon name="logout" /></button>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
